import camelcaseKeys from 'camelcase-keys';
import { SchedulerInboundEvents } from '~/components/Builder/Mobile/builderMobileApi.enums';
import { SchedulerOutboundEvents } from '~/components/Builder/Mobile/builderMobileApi.enums';
import BaseAbstractBuilderApi from '~/components/Builder/Mobile/Entities/BaseAbstractBuilderApi';
import type BuilderMobileCoreApiHandler from '~/components/Builder/Mobile/Entities/Core/BuilderMobileCoreApiHandler';
import type { IMobileAppService } from '~/components/Builder/Mobile/builderMobileApi.types';
import type { RootStore } from '~/stores/root.store';
import { ScheduleContainerBlock } from '~/models/blocks/schedule-container-block.model';
import { FlowMXContextValue } from '~/components/Builder/FlowMX.provider';
import { formatDateWithTimezone } from '~/utils/timezone.utils';

export class BuilderMobileSchedulerApiHandler extends BaseAbstractBuilderApi {
    builderMobileCoreApi: BuilderMobileCoreApiHandler;

    constructor(
        rootStore: RootStore,
        flowMXContext: FlowMXContextValue,
        MobileAppService: IMobileAppService,
        builderMobileCoreApi: BuilderMobileCoreApiHandler
    ) {
        super(rootStore, flowMXContext, MobileAppService);
        this.builderMobileCoreApi = builderMobileCoreApi;
        Object.values(SchedulerInboundEvents).forEach(schedulerInboundEvent => {
            this.subscribeToEvent(schedulerInboundEvent);
        });
    }

    // INBOUND EVENTS

    [SchedulerInboundEvents.CancelSession]({
        flowId,
        variableId
    }: {
        flowId: string;
        variableId: string;
    }) {
        const flow = this.rootStore.flowStore.flows[flowId];
        this.rootStore.scheduleCtrl.cancelSession({ flow, variableId });
    }

    // OUTBOUND EVENTS
    [SchedulerOutboundEvents.ViewMeetingDetails]({
        connected_variable_id,
        sessionClient,
        selectedDate,
        displayTimezone,
        connectedVariable,
        isFutureMeeting
    }: ScheduleContainerBlock) {
        const formattedDate = formatDateWithTimezone(
            selectedDate,
            displayTimezone
        );

        const camelizedValue = camelcaseKeys(connectedVariable.value, {
            deep: true
        });

        this.MobileAppService.triggerAppEvent(
            SchedulerOutboundEvents.ViewMeetingDetails,
            {
                isFutureMeeting,
                variableId: connected_variable_id,
                selectedDate: formattedDate,
                clientName: sessionClient.full_name,
                ...camelizedValue
            }
        );
    }
}
